const CVR_NUMBER_PATTERN = /^\d{8}$/

/** Navigate to company profile or search results from a header/home query. */
export function searchNavigationTarget(query: string): string | null {
  const q = query.trim()
  if (!q) return null
  if (CVR_NUMBER_PATTERN.test(q)) return `/company/${q}`
  return `/search?q=${encodeURIComponent(q)}`
}
